import { Table } from 'reactstrap';
import { Input } from '@availity/form';
import { useTranslation } from 'react-i18next';

import { TIME_SLOTS, WEEKDAYS } from '../../config/sendScheduleSlots';

const cellInputStyle = {
  border: '1px solid #555',
  textAlign: 'center',
  padding: '4px',
  width: '100%',
};

const SendScheduleMatrix = () => {
  const { t } = useTranslation();

  return (
    <Table bordered size="sm" responsive className="mb-0">
      <thead>
        <tr>
          <th style={{ width: '140px' }}>{t('Time Slot')}</th>
          {WEEKDAYS.map((day) => (
            <th key={day.key} className="text-center">
              {t(day.label)}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {TIME_SLOTS.map((slot) => (
          <tr key={slot.key}>
            <th scope="row">{slot.label}</th>
            {WEEKDAYS.map((day) => {
              const fieldName = `sendSchedule.matrix.${slot.key}.${day.key}`;
              return (
                <td key={day.key} style={{ padding: '4px' }}>
                  <Input
                    id={fieldName}
                    name={fieldName}
                    type="number"
                    min={0}
                    step="1"
                    style={cellInputStyle}
                  />
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default SendScheduleMatrix;
